import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import clsx from "clsx";
import _isEqual from "lodash/isEqual";
import React, { useState, useEffect } from "react";
import { PriceRangeInfos } from "../../util/types";
import { PriceCalculatorProps } from "./props";
import { classes, Root } from "./styles";
import {
  authorizedKeyCodes,
  PriceCalculatorInput,
  INITIAL_INPUT,
} from "./tools";

const PriceCalculator = ({
  mode,
  fieldLabel,
  getPriceRangeInfos,
  renderDetailedResult,
}: PriceCalculatorProps) => {
  const [input, setInput] = useState<PriceCalculatorInput>(INITIAL_INPUT);
  const [ranges, setRanges] = useState<PriceRangeInfos[] | null>(null);
  const [detail, setDetail] = useState<React.ReactNode | null>(null);

  const handleChange = (event: any) => {
    const value = event.target.value;
    if (value !== input.value) {
      setInput((prev) => ({
        ...prev,
        value: Number(value),
      }));
    }
  };

  const handleKeyPress = (event: any) => {
    if (!authorizedKeyCodes.includes(event.code)) {
      setInput((prev) => ({
        ...prev,
        error: "Veuillez saisir un chiffre entre 1 et 9.",
      }));
      event.preventDefault();
    } else {
      setInput((prev) => ({
        value: prev.value,
      }));
    }
  };

  const handleCalculate = (event: any) => {
    event.preventDefault();
    let nextRanges: PriceRangeInfos[] | null = null;

    if (input.value) {
      nextRanges = getPriceRangeInfos(input.value);
    }

    if (!_isEqual(ranges, nextRanges)) setRanges(nextRanges);
  };

  const handleReset = () => {
    setInput(INITIAL_INPUT);
    setRanges(null);
  };

  useEffect(() => {
    if (!input.value) setRanges(null);
  }, [input.value]);

  useEffect(() => {
    setDetail(
      renderDetailedResult(ranges, input, {
        alert: classes.marginBottom,
        bold: classes.bold,
      })
    );
  }, [ranges]);

  return (
    <Root>
      <Typography align="center" variant="h4" className={classes.marginBottom}>
        {`Calculez votre abonnement ${mode} : `}
      </Typography>

      <form
        onSubmit={handleCalculate}
        className={clsx(classes.form, classes.marginBottom)}
      >
        <TextField
          error={Boolean(input.error)}
          label={fieldLabel}
          helperText={input.error}
          value={input.value || ""}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          inputProps={{
            min: 0,
            step: 1,
            type: "number",
          }}
        />
        <Button
          variant="contained"
          type="submit"
          disabled={!input.value}
          onClick={handleCalculate}
          className={clsx(classes.button, classes.contained)}
        >
          Calculer !
        </Button>
        <Button
          variant="outlined"
          disabled={!input.value}
          onClick={handleReset}
          className={clsx(classes.button, classes.outlined)}
        >
          Effacer
        </Button>
      </form>
      {detail}
    </Root>
  );
};

export default PriceCalculator;
